import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { ImageSectionStyled } from '../ImageSectionStyled';
import { rem } from 'polished';

export const ImageSectionStyledDS = styled(ImageSectionStyled)`
    .delivery {
        background: ${({ theme }) => theme.colors.grey4};
    }

    .redirectLink {
        font-size: ${({ theme }) => theme.fontSizes.h5};

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};

            span {
                border-color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .image-wrapper {
        @media (max-width: ${breakpoints.sm}px) {
            height: 55vw;
        }
    }

    .react-multiple-carousel__arrow {
        border-radius: ${rem(3)};
        width: ${rem(48)};
        height: ${rem(48)};

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.grey4};
            border-color: ${({ theme }) => theme.colors.primary};

            &::before {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .toggle {
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.grey16};

        .ext,
        .int {
            width: ${rem(36)};

            &:hover {
                background: ${({ theme }) => theme.colors.grey16};
            }

            &.active {
                background: ${({ theme }) => theme.colors.grey16};
            }
        }
    }

    .dealer {
        .link {
            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }

        .address {
            color: ${({ theme }) => theme.colors.grey29};
        }
    }
`;
